import { NOTIFICATION_PROMPT_KEY } from './constants';

export const setDismissed = (value: boolean) => {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(NOTIFICATION_PROMPT_KEY, JSON.stringify(value));
    }
  } catch (error) {
    console.warn(
      'Failed to access localStorage, unable to set notification prompt state',
      error
    );
  }
};

export const isDismissed = () => {
  try {
    if (typeof localStorage !== 'undefined') {
      const value = localStorage.getItem(NOTIFICATION_PROMPT_KEY) as string;
      return value ? (JSON.parse(value) as boolean) : false;
    }
  } catch (error) {
    console.warn(
      'Failed to access localStorage, unable to get notification prompt state',
      error
    );
  }

  return false;
};
